export default class Config {
    static baseUrl() {
        if (window.location.hostname === "localhost") {
            return "http://localhost:30303";
        } else {
            return "";
        }
    }
}